// References
// https://stackoverflow.com/questions/69404843/react-joyride-not-accepting-custom-tooltip
// https://github.com/gilbarbara/react-joyride/blob/main/src/components/Tooltip/Container.js
import { TourtipCloseButton } from "./tourtip-close-button"


interface Tourtip {
  continuous: boolean // If the tour is continuous or not
  index: number // The current step's index
  isLastStep: boolean // The name says it all
  size: number // The number of steps in the tour
  step: any // The current step data
  backProps: any // The back button's props
  closeProps: any // The close button's props
  primaryProps: any // The primary button's props (Close or Next if the tour is continuous)
  skipProps: any // The skip button's props
  tooltipProps: any // The root element props (including ref)
}



export const Tourtip = ({
  continuous,
  index,
  isLastStep,
  size,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
}: Tourtip) => {


  const {
    content,
    hideBackButton,
    hideCloseButton,
    hideFooter,
    showProgress,
    showSkipButton,
    title,
    styles,
  } = step;
  const { back, close, last, next, skip } = step.locale;
  const output: { primary: any, progress?: any, skip?: any, back?: any, close?: any } = {
    primary: close,
  };

  if (continuous) {
    output.primary = isLastStep ? last : next;

    if (showProgress) {
      output.progress = (
        <span className="tourtip__progress">
          {index + 1} of {size}
        </span>
      );
    }
  }

  if (showSkipButton && !isLastStep) {
    output.skip = (
      <button
        style={styles.buttonSkip}
        type="button"
        data-test-id="button-skip"
        aria-live="off"
        {...skipProps}
      >
        {skip}
      </button>
    );
  }

  if (!hideBackButton && index > 0) {
    output.back = (
      <button style={styles.buttonBack} type="button" data-test-id="button-back" {...backProps}>
        {back}
      </button>
    );
  }

  output.close = !hideCloseButton && (
    <TourtipCloseButton styles={styles.buttonClose} data-test-id="button-close" {...closeProps} />
  );

  // console.log(styles.tooltip);

  return (
    <div
      key="JoyrideTooltip"
      className="tourtip"
      style={{width: styles.tooltip.width}}
      {...tooltipProps}
    >
      <div className="tourtip__container">
        {title && (
          <h4 className="tourtip__container-title" aria-label={title}>
            {title}
          </h4>
        )}
        <div className="tourtip__container-content">{content}</div>
      </div>
      {!hideFooter && (
        <div className="tourtip__footer">
            {output.progress}
          {/* {output.back} */}
          <button
            className="tourtip__primary-button"
            type="button"
            data-test-id="button-primary"
            {...primaryProps}
          >
            {output.primary === last ? 'Finish' : output.primary }
          </button>
        </div>
      )}
      {output.close}
    </div>
  );
}
